<template>
  <div class="body">
    <!--  头部  -->
    <div class="head">
      <div class="language" @click="">
        <div v-if="toggle" class="chese"><img src="../../static/ico-chinese.png"/>中文</div>
        <div v-else class="english"><img src="../../static/ico-english.png"/>EN</div>
      </div>
      <div class="logo">
        <img alt="" src="../../static/headlogo.png">
      </div>
      <div class="des">
        <span>北京中国国际展览中心 (新馆)</span> <span>2023年10月25-28日</span>
      </div>
    </div>

    <div class="content">
      <p class="title">
        参观预登记
      </p>
      <p class="des">
        如已注册，请移步第二十届中国国际煤炭采矿技术交流及设备展览会网站 www.chinaminexpo.com 进行登录。
      </p>


      <div class="information">
        <p class="title">
          填写信息
        </p>

        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item
              label="手机"
              prop="phone"
          >
            <el-input
                v-model="form.phone"
                autocomplete="off"
                placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="手机验证码"
              prop="verificationCode"
          >
            <el-input
                v-model="form.verificationCode"
                :disabled="!checkcode"
                autocomplete="off"
                placeholder="请输入验证码（填写3333）"
            >
              <el-button slot="append" :disabled="checkcode" @click="sendCode">{{ codeText }}</el-button>
            </el-input>
          </el-form-item>

          <el-form-item
              label="姓名"
              prop="name"
          >
            <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="请输入您身份证上的姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="称呼" label-position="top" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio label="0">先生</el-radio>
              <el-radio label="1">女士</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
              label="身份证号码"
              prop="ID"
          >
            <el-input
                v-model="form.ID"
                autocomplete="off"
                placeholder="请输入您的证件号"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="单位名称"
              prop="companyName"
          >
            <el-input
                v-model="form.companyName"
                autocomplete="off"
                placeholder="请输入公司名称"
                maxlength="50" show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item
              label="地址"
              prop="Address"
          >
            <el-input
                v-model="form.Address"
                autocomplete="off"
                placeholder="请输入您的通信地址"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="电话"
              prop="Telephone"
          >
            <el-input
                v-model="form.Telephone"
                autocomplete="off"
                placeholder="请输入您的电话"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="E-mail"
              prop="Email"
          >
            <el-input
                v-model="form.Email"
                autocomplete="off"
                placeholder="请输入您的邮箱"
            ></el-input>
            <div class="tips">
              用于接收预登记确认函，建议使用个人工作邮箱，避免使用公共邮箱
            </div>
          </el-form-item>



          <el-form-item
              label="设置密码"
              prop="pass"
          >
            <el-input
                type="password"
                v-model="form.pass"
                autocomplete="off"
                placeholder="请设置密码"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="确认密码"
              prop="checkPass"
          >
            <el-input
                type="password"
                v-model="form.checkPass"
                autocomplete="off"
                placeholder="请再次输入设置的密码"
            ></el-input>
          </el-form-item>

          <!--          <el-form-item-->
          <!--              label="<br/> "-->
          <!--              prop="checkPass"-->
          <!--          >-->
          <!--            <input type="checkbox" v-bind:checked="isChecked" v-on:click="handleDisabled"/>-->
          <!--              同意 <a href="">“隐私保护声明”</a>-->
          <!--            <br>-->
          <!--            <el-button>下一步</el-button>-->
          <!--          </el-form-item>-->
        </el-form>

        <div class="agree">
          <input type="checkbox" :checked="isChecked" @click="handleDisabled"/>
          <span>同意  <a href="#">“隐私保护声明”</a></span>
        </div>
        <el-button type="primary" class="next" :disabled="isDisabled" @click="submit">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wxRegister",
  created() {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 10 + 'px'; //动态的设置html的font-size恒等屏幕的1/10
  },
  //消除app.vue设置的样式
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'min-width:auto')
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else if (value !== this.verificationCode) {
        callback(new Error('验证码错误！请检查是否输入正确'));
      } else {
        callback();
      }
    };
    return {
      codeText: '获取手机验证码',
      checkcode: false,
      isChecked: false,         //是否勾选同意
      isDisabled: true,         //禁用下一步
      toggle: '',
      verificationCode: '', //验证码
      form: {
        phone: '',
        verificationCode: '',
        name: '',
        gender: '0',
        ID: '',
        companyName: '',
        Address: '',
        Telephone: '',
        Email: '',
        pass: '',
        checkPass: '',
      },
      rules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validatePhone, trigger: 'blur', required:'true' }
        ],
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        gender: [
          {required: true, message: '性别不能为空', trigger: 'blur' }
        ],
        ID: [
          {required: true, message: '身份证号不能为空', trigger: 'blur' }
        ],
        companyName: [
          {required: true, message: '单位名称不能为空', trigger: 'blur' }
        ],
        Address: [
          {required: true, message: '地址不能为空', trigger: 'blur' }
        ],
        Telephone: [],
        Email: [
          {required: true, message: '邮箱不能为空', trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur', required:'true' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required:'true' }
        ]
      }
    }
  },
  methods: {
    //发送验证码
    sendCode () {
      this.codeText = '已发送';
      this.checkcode = !this.checkcode;
      this.verificationCode = '3333';
    },
    //选中同意
    handleDisabled () {
      this.isChecked = !this.isChecked;
      this.isDisabled = this.isChecked !== true;
    },
    //提交表单
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          //修改密码逻辑
          // alert('submit!');
          this.$router.push('wxQuestion')
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
$ue-width: 750; /* 设计稿图的宽度 */
//rem
@function px2rem($px) {
  @return #{$px/$ue-width*10}rem;
}

.body {

  font-family: PingFangSC-Regular, PingFang SC;
  .head {
    //width: px2rem(750);
    background: #006FB8; /*编译后：  p{width:1.5625rem}*/
    padding: px2rem(30) px2rem(25) px2rem(20);

    .language {
      color: #FFFFFF;
      margin-bottom: px2rem(28);

      img {
        width: px2rem(34);
        height: px2rem(34);
      }

      .english,
      .chese {
        display: flex;
        font-size: px2rem(28);
        font-weight: 400;
        align-items: center;
        justify-content: flex-end;
      }

    }

    .logo {
      width: px2rem(700);

      img {
        max-width: 100%;
        width: 100%;
      }
    }

    .des {
      font-size: px2rem(24);
      color: rgba(255, 255, 255, 0.85);
      font-weight: 500;
      margin-left: px2rem(112);

      span {
        margin-right: px2rem(15);
      }
    }
  }

  .content {
    //background: #d7d8dd;
    padding: px2rem(36) px2rem(40) px2rem(50);

    .title {
      font-size: px2rem(36);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: px2rem(19);
    }

    .des {
      font-size: px2rem(24);
      line-height: px2rem(33);
      color: #999999;
      margin-bottom: px2rem(50);
    }

    //表单
    .information {
      .title {
        font-size: px2rem(32);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-bottom: 0;
      }

      .tips {
        font-size: px2rem(24);
        color: #999999;
        line-height: px2rem(33);
        margin-top: px2rem(15);
      }

      .agree {
        display: flex;
        align-items: center;
        margin-top: px2rem(40);
        font-size: px2rem(28);
        input {
          width: px2rem(30);
          height: px2rem(30);
          margin-right: px2rem(20);
        }
        a {
          text-decoration: none;
          color: #006FB8;
          font-size: px2rem(28);
        }
      }

      .next {
        width: 100%;
        //height: px2rem(72);
        //background: #006FB8;
        //color: #FFFFFF;
        //border: 0;
        //border-radius: 4px;
        font-size: px2rem(32);
        font-family: PingFangSC-Regular, PingFang SC;
      }

      ::v-deep .el-input-group__append {
        background: #006FB8;
        color: #FFFFFF;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: px2rem(32);
        font-weight: 400;
        height: px2rem(72);
        line-height: px2rem(72);
        border: none;
        width: 40%;
      }

      .el-button.is-disabled:focus, .el-button.is-disabled:hover {
        color: #C0C4CC;
        cursor: not-allowed;
        background-image: none;
        background-color: transparent;
        border-color: transparent;
      }

      ::v-deep .el-form-item {
        margin-bottom: 0;
      }

      //修改单选样式
      ::v-deep .el-radio__inner {
        width: px2rem(32);
        height: px2rem(32);
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        color: #006FB8;
        background: #FFFFFF;
      }

      ::v-deep .el-radio__inner::after {
        width: px2rem(20);
        height: px2rem(20);
        background: #006FB8;
      }

      ::v-deep .el-radio__label {
        font-size: px2rem(28);
      }//修改单选样式结束

      ::v-deep .el-form-item__label {
        font-size: px2rem(28);
        line-height: px2rem(40);
        padding-bottom: 0;
        color: #333333;
        //margin-bottom: px2rem(10);
      }

      ::v-deep .el-form-item__content {
        line-height: px2rem(40);
      }

      ::v-deep .el-input__inner {
        height: px2rem(72);
        line-height: px2rem(72);
        font-size: px2rem(28);
      }

    }
  }
}

</style>

<style scoped>

</style>

<style>

</style>
